// @ts-nocheck
/* eslint-disable */
import { niAngleRightIcon } from './angle_right';
import { niArrowDownIcon } from './arrow_down';
import { niArrowUpIcon } from './arrow_up';
import { niCheckIcon } from './check';
import { niChevronRightNewIcon } from './chevron-right-new';
import { niCloseIcon } from './close';
import { niDownloadIcon } from './download';
import { niDropdownDownIcon } from './dropdown-down';
import { niIconSearchIcon } from './icon-search';
import { niInfoIcon } from './info';
import { niNavLeftMobileInactiveIcon } from './nav-left-mobile-inactive';
import { niNavLeftMobileIcon } from './nav-left-mobile';
import { niNavLeftIcon } from './nav-left';
import { niNavRightMobileInactiveIcon } from './nav-right-mobile-inactive';
import { niNavRightMobileIcon } from './nav-right-mobile';
import { niNavRightIcon } from './nav-right';
import { niTableSortDesktopAscIcon } from './table-sort-desktop-asc';
import { niTableSortDesktopDefaultIcon } from './table-sort-desktop-default';
import { niTableSortDesktopDescIcon } from './table-sort-desktop-desc';
import { niTableSortMobileAscIcon } from './table-sort-mobile-asc';
import { niTableSortMobileDefaultIcon } from './table-sort-mobile-default';
import { niTableSortMobileDescIcon } from './table-sort-mobile-desc';
import { niTableSortTabletAscIcon } from './table-sort-tablet-asc';
import { niTableSortTabletDefaultIcon } from './table-sort-tablet-default';
import { niTableSortTabletDescIcon } from './table-sort-tablet-desc';
import { niTimesIcon } from './times';
export const niIcons = [niAngleRightIcon, niArrowDownIcon, niArrowUpIcon, niCheckIcon, niChevronRightNewIcon, niCloseIcon, niDownloadIcon, niDropdownDownIcon, niIconSearchIcon, niInfoIcon, niNavLeftMobileInactiveIcon, niNavLeftMobileIcon, niNavLeftIcon, niNavRightMobileInactiveIcon, niNavRightMobileIcon, niNavRightIcon, niTableSortDesktopAscIcon, niTableSortDesktopDefaultIcon, niTableSortDesktopDescIcon, niTableSortMobileAscIcon, niTableSortMobileDefaultIcon, niTableSortMobileDescIcon, niTableSortTabletAscIcon, niTableSortTabletDefaultIcon, niTableSortTabletDescIcon, niTimesIcon];
